import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export interface Slide {
    id: number;
    title: string;
    description: string;
    image: string;
}

interface Props {
    slides: Slide[];
}

const FeatureSlider: React.FC<Props> = ({ slides }) => {
    return (
        <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            loop
            autoplay={{
                delay: 4000,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true,
            }}
            className="feature-slider"
        >
            {slides.map((slide) => (
                <SwiperSlide key={slide.id}>
                    <div className="p-4 h-100">
                        <div className="h-100 border-0">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col-lg-6 mb-3 mb-lg-0">
                                        <h5 className="fw-bold text-start feature-slider-title">{slide.title}</h5>
                                        <p className="text-start mb-0 feature-slider-description">
                                            {slide.description}
                                        </p>
                                    </div>

                                    <div className="col-lg-6 text-center">
                                        <img
                                            src={slide.image}
                                            alt={slide.title}
                                            className="img-fluid rounded feature-slider-image"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default FeatureSlider;
